import Content from '../components/Content';
import FullForm from '../components/main/book/FullForm';
import MainBookFormStore from '../stores/MainBookFormStore';
import { useNavigate } from 'react-router';

const MainBookCreate = ({ userStore, snackStore }) => {
  const navigate = useNavigate();
  const mainBookFormStore = new MainBookFormStore(userStore, snackStore, navigate);

  return (
    <Content title="Criar novo Livro-Pai" userStore={userStore}>
      <FullForm userStore={userStore} mainBookFormStore={mainBookFormStore} snackStore={snackStore} />
    </Content>
  );
};

export default MainBookCreate;
